import {
  INQUIRY_FF_ENABLE_LOADING,
  INQUIRY_FF_SET_BID_MASTER_DATA,
  INQUIRY_FF_SET_BID_MASTER_LOAD_ERROR,
  INQUIRY_FF_DISABLE_LOADING,
  INQUIRY_FF_SET_RECENT_BIDS,
  INQUIRY_FF_RECENT_BID_LOAD_ERROR,
  INQUIRY_FF_SET_RECENT_BID_PAGINATION,
  INQUIRY_FF_BIDS_SET_FILTER,
  INQUIRY_FF_BIDS_APPLY_FILTER,
  INQUIRY_FF_BIDS_RESET_FILTERS,
  INQUIRY_FF_BIDS_ENABLE_LOADING,
  INQUIRY_FF_BIDS_DISABLE_LOADING,
  INQUIRY_FF_BIDS_GET_ALL_BIDS,
  INQUIRY_FF_BIDS_GET_ALL_BIDS_FETCH_ERROR,
  INQUIRY_FF_SET_INQUIRY_DETAIL_DATA,
  INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR,
  INQUIRY_FF_CREATE_BID_SET_CHARGES,
  INQUIRY_FF_BID_CHARGES_LOADING,
  INQUIRY_FF_CREATE_BID_PAGE_FORM,
  INQUIRY_FF_ADD_NEW_CHARGE,
  INQUIRY_FF_SET_UPDATE_CHARGE_ENTITIES,
  INQUIRY_FF_RECENT_BID_LOADING,
  INQUIRY_FF_DELETE_CHARGE,
  INQUIRY_FF_BID_SET_INIT_CHARGE_DETAILS,
  INQUIRY_FF_ADD_RESET_DATA,
  INQUIRY_FF_SET_PORTS,
  INQUIRY_SET_LINKED_FFS_FOR_INQUIRY,
} from './constants';
import {
  getBidMasterForInquiry,
  fetchRecentInquiryBidsForFF,
  fetchAllFFBidsInquiry,
  getBidChargesApi,
  getInquiryDetailsForBidApi,
  getExchangeRate,
  fetchLinkedFFsForInquiry,
} from 'src/api/inquiry';
import { getLastSortedColumnValue, getLastRFQColumnId } from 'src/utils/pagination';
import { isValidNumber } from 'src/Library/Helper';
import { InquiryModes } from 'src/Library/Constants';
import { modeWiseDefaultCarrierCodeKey } from 'src/components/pages/Enquiry/InquiryUtils';

export const getBidsFF = (id, applyFilter = true) => async (dispatch, getState) => {
  dispatch({
    type: INQUIRY_FF_BIDS_ENABLE_LOADING,
  });
  const appliedFilters = applyFilter ? getState().inquiryFFBidsReducer.selectedFilters : {};
  const pagination = getState().inquiryFFBidsReducer.pagination;
  const inquiryId = id;
  const sortBy = appliedFilters.sortBy || 'transit_time';
  const carrierList = appliedFilters.shippingLineList ? appliedFilters.shippingLineList : [];
  const currentPageNumber = pagination.currentPageNumber ? pagination.currentPageNumber : 1;
  const descendingOrder = appliedFilters.descendingOrder;
  const bidIdList = appliedFilters.bidIdList;
  const bidStatusList = appliedFilters.bidStatusList ? appliedFilters.bidStatusList :
  ['ACTIVE', 'DELETED'];
  const body = {
    inquiryId,
    bidIdList,
    sortBy,
    carrierList,
    currentPageNumber,
    descendingOrder,
    bidStatusList,
  };
  const response: any = await fetchAllFFBidsInquiry(body);
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_FF_BIDS_GET_ALL_BIDS,
      data: response.data,
    });
  } else {
    dispatch({
      type: INQUIRY_FF_BIDS_GET_ALL_BIDS_FETCH_ERROR,
      errorMessage: response.errorMessage,
    });
  }
  dispatch({
    type: INQUIRY_FF_BIDS_DISABLE_LOADING,
  });
};

export const setPortsOptions = (setPortsOf, ports) => (dispatch) => {
  dispatch({
    type: INQUIRY_FF_SET_PORTS,
    data: {
      setPortsOf,
      ports,
    },
  });
};

export const deleteCharge = body => async (dispatch, getState) => {
  const charges = getState().inquiryFFBidsReducer.createBidData.bidCharges;
  const newCharges: any = [];
  charges[body.key].values.map((item) => {
    if (item.key !== body.chargeKey) {
      newCharges.push(item);
    }
  });
  dispatch({
    type: INQUIRY_FF_DELETE_CHARGE,
    data: {
      key: body.key,
      values: newCharges,
    },
  });
};

export const setPagination = clickOn => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_SET_RECENT_BID_PAGINATION,
    data: {
      nextOrPrev: clickOn,
    },
  });
  dispatch(fetchRecentBidsApi());
};

export const setFilter = body => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_BIDS_SET_FILTER,
    data: body,
  });
};

const getBidChargesFromBidData = (chargeDetails) => {
  const newCharges: any = {};
  let key = 1;
  Object.keys(chargeDetails).map((charge) => {
    newCharges[charge] = {
      name: chargeDetails[charge].name,
      values: [],
    };
    chargeDetails[charge].values.map((item) => {
      newCharges[charge].values.push({
        ...item,
        key,
      });
      key = key + 1;
    });
  });
  return newCharges;
};

export const prefillBidData = data => async (dispatch) => {
  await dispatch({
    type: INQUIRY_FF_BID_CHARGES_LOADING,
    data: true,
  });
  await dispatch(setCreateBidFilter({
    shippingLine: data.ffCarrier,
    loadingPort: data.portOfLoading?.code,
    destinationPort: data.portOfDischarge?.code,
    ff: data.ffId,
  }, true));
  const bidCharges = getBidChargesFromBidData(data.chargeDetails);
  await dispatch({
    type: INQUIRY_FF_CREATE_BID_SET_CHARGES,
    data: bidCharges,
  });
  await dispatch(setChargeDetailsCounts(bidCharges, true));
  await dispatch({
    type: INQUIRY_FF_BID_CHARGES_LOADING,
    data: false,
  });
};

export const applyFilter = inquiryId => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_BIDS_APPLY_FILTER,
  });
  dispatch(getBidsFF(inquiryId));
};
export const getBidMaster = body => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_ENABLE_LOADING,
  });
  dispatch(getMasterDataApi(body));
};
const getMasterDataApi = body => async (dispatch) => {
  const response = await getBidMasterForInquiry(body);
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_FF_SET_BID_MASTER_DATA,
      data: response.data,
    });
  } else {
    dispatch({
      type: INQUIRY_FF_SET_BID_MASTER_LOAD_ERROR,
      data: response.errorMessage,
    });
  }
  dispatch({
    type: INQUIRY_FF_DISABLE_LOADING,
  });
};

export const fetchRecentBidsApi = () => async (dispatch, getState) => {
  const pagination = getState().inquiryFFBidsReducer.paginationCreateBid;
  const formValues = getState().inquiryFFBidsReducer.createBidData.formValues;
  const { shippingLine, loadingPort, destinationPort, inquiryId, userType } = formValues;
  // recent bids should be based on pol, pod and carrier for FF side
  if (!(shippingLine && loadingPort && destinationPort && userType && userType === 'FF')) {
    return;
  }
  dispatch({
    type: INQUIRY_FF_RECENT_BID_LOADING,
  });
  const response = await fetchRecentInquiryBidsForFF({
    inquiryId,
    validTill: null,
    timeFilter: 'ALL',
    descendingOrder: true,
    nextOrPrev: pagination.nextOrPrev,
    lastSortedColumnValue: getLastSortedColumnValue(pagination),
    lastBidId: getLastRFQColumnId(pagination),
    currentPageNumber: pagination.currentPageNumber,
    resultPerPage: pagination.resultPerPage,
    carrierList: [shippingLine],
    polId: loadingPort,
    podId: destinationPort,
  });
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_FF_SET_RECENT_BIDS,
      data: response.data,
    });
  } else {
    dispatch({
      type: INQUIRY_FF_RECENT_BID_LOAD_ERROR,
      data: response.errorMessage,
    });
  }
};

export const clearRecentBids = () => (dispatch) => {
  dispatch({
    type: INQUIRY_FF_SET_RECENT_BIDS,
    data: [],
  });
};

export const resetFilters = ffId => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_BIDS_RESET_FILTERS,
  });
  dispatch(getBidsFF(ffId));
};
export const getBidCharges = body => async (dispatch) => {
  const response = await getBidChargesApi(body);
  if (response.isSuccess) {
    await dispatch({
      type: INQUIRY_FF_CREATE_BID_SET_CHARGES,
      data: response.data,
    });
    await dispatch(setChargeDetailsCounts(response.data));
  } else {
    dispatch({
      type: INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR,
      data: response.errorMessage,
    });
  }
};

const getCurrencyChargesData = async (data: any, defaultCurrency, id) => {
  const setOfCurrency = new Set(data);
  const exchangeRates: any = {};
  for (const item of Array.from(setOfCurrency)) {
    const apiResult = await getExchangeRate({
      inquiryId: id,
      currentCurrency: item,
      finalCurrency: defaultCurrency,
    });
    if (apiResult.isSuccess) {
      exchangeRates[`${item}`] = apiResult.data.rate;
    }
  }
  return exchangeRates;
};

export const resetData = () => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_ADD_RESET_DATA,
  });
};

export const setChargeDetailsCounts = (data, disable = false) => async (dispatch, store) => {
  const {
    bidChargeTaxes,
    inquiryDetails : { mode },
  } = store().inquiryFFBidsReducer.createBidData.inquiryData;
  const inquiryConfig = store().masterData?.inquiry;
  const taxCodeMap: Record<string, number> = (inquiryConfig?.isTaxMappingEnabled && Array.isArray(inquiryConfig?.taxCodeMapping) && inquiryConfig.taxCodeMapping.length)
    ? inquiryConfig.taxCodeMapping.reduce((acc: Record<string, number>, entry: Record<string, number>) => {
        const [taxName, taxValue] = Object.entries(entry)[0];
        acc[taxName] = taxValue / 100;
        return acc;
      }, {})
    : {};
  const effectiveTaxMap: Record<string, number> = {
    ...bidChargeTaxes,
    ...taxCodeMap,
  };
  const { selectedFFCurrency } = store().inquiryFFBidsReducer.createBidData.formValues;
  const defaultCurrency = selectedFFCurrency ||
    store().inquiryFFBidsReducer.createBidData.inquiryData.defaultCurrency;
  const inquiryId = store().inquiryFFBidsReducer.createBidData.formValues.inquiryId;
  const chargeDetails: any = {
    disabledCharges: {},
    currencies: {},
    prices: {},
    unitCounts: {},
    taxes: {},
    exchangeRates: {},
    totalCounts: {},
    totalDefault: {},
    ...(mode === 'FCL' && {
      perContainerCounts: {},
    }),
  };
  const currencyList: any = [defaultCurrency, 'USD'];
  Object.keys(data).map((key) => {
    for (const item of data[key].values) {
      const { unitCount } = item;
      if (item.currency) {
        currencyList.push(item.currency);
        chargeDetails.currencies = {
          ...chargeDetails.currencies,
          [item.key]: item.currency,
        };
      } else {
        chargeDetails.currencies = {
          ...chargeDetails.currencies,
          [item.key]: defaultCurrency,
        };
      }
      if (item.price || item.price === 0) {
        chargeDetails.prices = {
          ...chargeDetails.prices,
          [item.key]: item.price,
        };
      } if (isValidNumber(unitCount)) {
        const unitCountValue = getUnitCount(mode, unitCount);
        chargeDetails.unitCounts = {
          ...chargeDetails.unitCounts,
          [item.key]: unitCountValue,
        };
        if (mode === 'FCL' && item.unitType === 'Per Container') {
          chargeDetails.perContainerCounts = {
            ...chargeDetails.perContainerCounts,
            [item.key]: unitCount,
          };
        }
      }
      chargeDetails.taxes = {
        ...chargeDetails.taxes,
        [item.key]: item.tax ? effectiveTaxMap[item.tax] : 0,
      };
      if (item.price && item.ffTotal && item.ffTotal.amount && !disable) {
        chargeDetails.disabledCharges = {
          ...chargeDetails.disabledCharges,
          [item.key]: true,
        };
      } else {
        chargeDetails.disabledCharges = {
          ...chargeDetails.disabledCharges,
          [item.key]: false,
        };
      }
    }
  });
  chargeDetails.exchangeRates = await getCurrencyChargesData(currencyList,
    defaultCurrency, inquiryId);
  chargeDetails.totalCounts = getTotalCounts(chargeDetails,
    defaultCurrency, store);
  chargeDetails.totalDefault = getDefaultCounts(chargeDetails, store);
  await dispatch({
    type: INQUIRY_FF_BID_SET_INIT_CHARGE_DETAILS,
    data: chargeDetails,
  });
};

const getTotalCounts = (chargeDetails, defaultCurrency, getState) => {
  let totalCounts: any = {};
  const {
    inquiryDetails : { mode },
  } = getState().inquiryFFBidsReducer.createBidData.inquiryData;
  Object.keys(chargeDetails.currencies).map((item) => {
    let exchange: any = '1';
    if (defaultCurrency === chargeDetails.currencies[item]) {
      exchange = 1;
    } else if (chargeDetails.exchangeRates[chargeDetails.currencies[item]]) {
      exchange = Number(chargeDetails.exchangeRates[chargeDetails.currencies[item]]);
    }
    const price = Number(chargeDetails.prices[item] ? chargeDetails.prices[item] : 0);
    let unitCount = Number(chargeDetails.unitCounts[item]);
    unitCount = getUnitCount(mode, unitCount);
    const tax = Number(chargeDetails.taxes[item] ? chargeDetails.taxes[item] : 0);
    totalCounts = {
      ...totalCounts,
      [item]: exchange * price * unitCount * (1 + tax),
    };
  });
  return totalCounts;
};
const getDefaultCounts = (chargeDetails, getState) => {
  let defaultCounts: any = {};
  const { currencies, unitCounts } = chargeDetails;
  const {
    inquiryDetails : { mode },
  } = getState().inquiryFFBidsReducer.createBidData.inquiryData;
  Object.keys(currencies).map((item) => {
    const price = Number(chargeDetails.prices[item] ? chargeDetails.prices[item] : 0);
    let unitCount = Number(unitCounts[item]);
    unitCount = getUnitCount(mode, unitCount);
    const tax = Number(chargeDetails.taxes[item] ? chargeDetails.taxes[item] : 0);
    defaultCounts = {
      ...defaultCounts,
      [item]: price * unitCount * (1 + tax),
    };
  });
  return defaultCounts;
};

export const getLinkedFFsForInquiry = body => async (dispatch) => {
  const response = await fetchLinkedFFsForInquiry(body);
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_SET_LINKED_FFS_FOR_INQUIRY,
      data: response.data ? response.data.map((item) => {
        return {
          key: item.id,
          label: item.name,
          currency: item.ffCurrency,
        };
      }) : [],
    });
  } else {
    dispatch({
      type: INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR,
      data: response.errorMessage,
    });
  }
};

export const getInquiryDetailsForBid = (body, newBid) => async (dispatch) => {
  const response = await getInquiryDetailsForBidApi(body);
  if (response.isSuccess) {
    dispatch({
      type: INQUIRY_FF_SET_INQUIRY_DETAIL_DATA,
      data: response.data,
    });
    if (response.data?.inquiryDetails?.mode === InquiryModes.TRAILER
      || response.data?.inquiryDetails?.mode === InquiryModes.DOMESTIC
      || response.data?.inquiryDetails?.mode === InquiryModes.RPTL
      ) return;
    const origin = response.data.inquiryDetails.origin;
    const destination = response.data.inquiryDetails.destination;
    if (origin?.portType !== 'DRY' || destination?.portType !== 'DRY') {
      dispatch(setCreateBidFilter({
        ...(origin?.portType !== 'DRY' && {
          loadingPort: origin?.port,
        }),
        ...(destination?.portType !== 'DRY' && {
          destinationPort: destination?.port,
        })
      }, newBid));
    }
  } else {
    dispatch({
      type: INQUIRY_FF_INQUIRY_DETAIL_LOAD_ERROR,
      data: response.errorMessage,
    });
  }
};

export const recentBidsFormChanges = (body, apiCall = true) => async (dispatch, getState) => {
  await dispatch({
    type: INQUIRY_FF_CREATE_BID_PAGE_FORM,
    data: body,
  });
  if (apiCall) await dispatch(fetchRecentBidsApi());
};

export const setCreateBidFilter = (body , newBid = false) => async (dispatch, getState) => {
  await dispatch({
    type: INQUIRY_FF_BID_CHARGES_LOADING,
    data: true,
  });
  await dispatch({
    type: INQUIRY_FF_CREATE_BID_PAGE_FORM,
    data: body,
  });
  const formValues = getState().inquiryFFBidsReducer.createBidData.formValues;
  const { shippingLine, loadingPort, destinationPort, inquiryId, userType, ffId } = formValues;
  if (body.inquiryId) {
    await dispatch(getInquiryDetailsForBid({
      inquiryId,
      userType,
    }, newBid));
    if (userType === 'SHIPPER') {
      await dispatch(getLinkedFFsForInquiry({
        inquiryId,
      }));
    }
  }
  const inquiryData = getState().inquiryFFBidsReducer.createBidData.inquiryData;
  if (!inquiryData?.inquiryDetails) return;
  const { inquiryDetails : { mode } } = inquiryData;
  const defaultCarrierCode = inquiryData?.[modeWiseDefaultCarrierCodeKey[mode]];
  const carrier = shippingLine || defaultCarrierCode;
  const trailerAndRoadModes = [InquiryModes.TRAILER, InquiryModes.DOMESTIC, InquiryModes.RPTL];
  if (!shippingLine && defaultCarrierCode && !newBid) {
    await dispatch({
      type: INQUIRY_FF_CREATE_BID_PAGE_FORM,
      data: { shippingLine: defaultCarrierCode },
    });
  }

  if (((carrier && loadingPort && destinationPort) ||
    (userType === 'SHIPPER' ?
      (ffId && trailerAndRoadModes.includes(mode)) 
      :
      trailerAndRoadModes.includes(mode) 
    )) 
      && !newBid) {
    await dispatch(getBidCharges({
      userType,
      inquiryId,
      carrier,
      pol: loadingPort,
      pod: destinationPort,
    }));
  }
  if (!newBid)  {
    await dispatch({
      type: INQUIRY_FF_BID_CHARGES_LOADING,
      data: false,
    });
  }
};
export const addNewCharge = newCharge => async (dispatch) => {
  dispatch({
    type: INQUIRY_FF_ADD_NEW_CHARGE,
    data: newCharge,
  });
  dispatch(setAndUpDateChargeDetails('currencies',
    newCharge.chargeKey, newCharge.currency));
};

const getUnitCount = (mode, unitCount) => {
  if (mode === 'LCL' && unitCount < 1) {
    return 1;
  }
  return unitCount
}

export const setAndUpDateChargeDetails = (item , key, val) => async (dispatch, getState) => {
  await dispatch({
    type: INQUIRY_FF_SET_UPDATE_CHARGE_ENTITIES,
    data: { item, key, val },
  });
  if (item === 'exchangeRates' || item === 'totalCounts'
    || item === 'totalDefault' || item === 'names') return;
  const chargeDetails = getState().inquiryFFBidsReducer.chargeDetails;
  const { prices, unitCounts, taxes, currencies, exchangeRates } = chargeDetails;
  const { selectedFFCurrency } = getState().inquiryFFBidsReducer.createBidData.formValues;
  const defaultCurrency = selectedFFCurrency ||
  getState().inquiryFFBidsReducer.createBidData.inquiryData.defaultCurrency;
  const { inquiryId } = getState().inquiryFFBidsReducer.createBidData.formValues;
  if ((prices[key] || prices[key] === 0) &&
    (unitCounts[key] || unitCounts[key] === 0) && currencies[key]) {
    let exchange: any = '1';
    if (defaultCurrency === currencies[key]) {
      exchange = 1;
      dispatch(setAndUpDateChargeDetails('exchangeRates',
        currencies[key], 1));
    } else if (exchangeRates[currencies[key]]) {
      exchange = Number(exchangeRates[currencies[key]]);
    } else {
      const response = await getExchangeRate({
        inquiryId,
        currentCurrency: currencies[key],
        finalCurrency: defaultCurrency,
      });
      if (response.isSuccess) {
        dispatch(setAndUpDateChargeDetails('exchangeRates',
          currencies[key], response.data.rate));
        exchange = Number(response.data.rate);
      } else return;
    }
    const price = Number(prices[key]);
    const unitCount = Number(unitCounts[key]);
    const tax = Number(taxes[key] ? taxes[key] : 0);
    dispatch(setAndUpDateChargeDetails('totalCounts', key,
      exchange * price * unitCount * (1 + tax)));
    if (defaultCurrency !== currencies[key]) {
      dispatch(setAndUpDateChargeDetails('totalDefault', key,
        price * unitCount * (1 + tax)));
    }
  }
  /*
    if unit type is changed to editable charge unit type
    unit count will be null hence we need to reset total of charge
  */
  if (typeof val === 'undefined') {
    dispatch(setAndUpDateChargeDetails('totalCounts', key, 0));
    dispatch(setAndUpDateChargeDetails('totalDefault', key, 0));
  }
};
